import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery, useMutation } from "react-apollo-hooks";
import {
  GIFT_CATEGORY_LIST_QUERY,
  GIFT_CATEGORY_DELETE_QUERY,
} from "../../Queries";
import Presenter from "./Presenter";
import { toast } from "react-toastify";

export default withRouter(({ history, match, location }) => {
  const { data, loading } = useQuery(GIFT_CATEGORY_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      giftConfig: match.params.config,
      parentId: "null",
    },
  });
  const [giftCategoryDeleteMutation] = useMutation(GIFT_CATEGORY_DELETE_QUERY, {
    refetchQueries: [
      {
        query: GIFT_CATEGORY_LIST_QUERY,
        variables: {
          giftConfig: match.params.config,
          parentId: "null",
        },
      },
    ],
    awaitRefetchQueries: true,
  });
  const onDelete = async (id) => {
    try {
      const {
        data: { AdminGiftCategoryDelete },
      } = await giftCategoryDeleteMutation({
        variables: {
          id: id,
        },
      });
      if (AdminGiftCategoryDelete) {
        toast.success("처리 되었습니다.");
        history.push(`/giftConfigs/${match.params.config}/categories`);
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  return (
    <>
      <Presenter
        history={history}
        match={match}
        location={location}
        data={data}
        loading={loading}
        onDelete={onDelete}
      ></Presenter>
    </>
  );
});
